import {
  isRendering
} from "../../chunk-5R2Z7TR6.mjs";

// src/transform/native-tag-var/index-browser.ts
function createElGetter(owner, key) {
  return owner[key] || (owner[key] = () => {
    if (isRendering()) {
      throw new Error("Cannot read an element reference while rendering.");
    }
    return owner.getEl(key);
  });
}
export {
  createElGetter as default
};
